<template>
  <div>
    <div class="varDialog" v-if="mode==='view'">
<!-- eslint-disable-next-line vue/no-mutating-props-->
      <draggable-dialog class="draggableDialog" id="varDialog" :show.sync="varDialogInfo.show" :closable="false"
         width="300px"
         top="466px"
         left="10px"
         position="fixed">
        <template #header>
          变量
        </template>
        <template #content>
          <div class="varList">
              <template v-if="varList.length > 0">
              <div v-for="variable in varList" class="varItem" :key="variable.id">
                <span class="varId" :title="variable.id">{{variable.id}}</span>
                <span class="varName" :title="variable.name">{{variable.name}}</span>
                <span v-if="mode === 'view'" class="varValue" :style="getValueColor(variable)" :title="variable.value">
                  {{variable.value}}
                </span>
              </div>
                <div style="clear: both;"></div>
              </template>
              <template v-else>
                <div style="text-align: center; margin-bottom: 15px;">无变量</div>
              </template>
          </div>
        </template>
      </draggable-dialog>
    </div>
  </div>
</template>

<script>
  import DraggableDialog from "@/components/ProductComponents/CreateComponents/DraggableDialog";
  // 深拷贝工具
  import deepClone from "../../../../config/deepCopy.js";
  export default {
    name: 'VarDialog',     // 变量展示框
    components: {
      DraggableDialog,
    },
    props: {
      varDialogInfo: Object,
      varList: Array,
      varJson: Object,
      compsJson: Object,
      mode: String,
      productId: Number,
      projectId: Number,
      varNum: Number,
    },
    data () {
      return {
        variablesNum: '',     // 页面可用变量数
        flag: 1,              //1-可以新增，0-不能新增，需要购买
        companyId: '',
        show: true,
      }
    },
    mounted () {
      this.newVarJson = deepClone(this.varJson)
    },
    watch: {
      'varModal.show': {  // 监视打开变量对话框时，进行原变量列表备份
        handler(val) {
          if(val === true){
            this.newVarJson = deepClone(this.varJson)
          }
        }
      },
    },
    methods: {
      getValueColor(variable) {
        let style = { color: 'black' }
        if(variable.allowAlert === true && (variable.value >= variable.highAlertValue || variable.value <= variable.lowAlertValue)) {
          style.color = 'red'
        }
        return style
      }
    }
  }
</script>

<style lang="less">
  .varDialog{
    #varDialog {
      z-index: 10000;  //原本为9999
    }
  .varList{
    height: 150px;
    overflow-y: auto;
  }
  .varList2{
    height: 350px;
    overflow-y: auto;
  }
    .varItem {
      height: 30px;
      line-height: 30px;
      .editVarBtn {
        float: right;
        padding: 0;
        cursor: pointer;
      }
      .deleteVarBtn {
        margin-left: 10px;
        float: right;
        padding: 0;
        cursor: pointer;
      }
      .varId {
        float: left;
        color: #a2a2a2;
        max-width: 6em;
        overflow: hidden;
        text-overflow:ellipsis;
        white-space: nowrap;
        display: inline-block;
      }
      .varName {
        float: left;
        margin-left: 10px;
        max-width: 6em;
        overflow: hidden;
        text-overflow:ellipsis;
        white-space: nowrap;
        display: inline-block;
      }
      .varDesp {
        color: gray;
        margin-left: 5px;
        &:before {
          content: " - ";
          margin: 5px;
        }
        max-width: 10em;
        overflow: hidden;
        text-overflow:ellipsis;
        white-space: nowrap;
        display: inline-block;
      }
      .varValue {
        color: gray;
        float: right;
        &:before {
          content: "value: ";
          margin: 5px;
        }
        max-width: 14em;
        overflow: hidden;
        text-overflow:ellipsis;
        white-space: nowrap;
        display: inline-block;
      }
    }

  }
</style>
